import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const HomeIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path stroke="currentColor" d="M4.5 10.5v10h5V17c0-1.5 1-2.5 2.5-2.5s2.5 1 2.5 2.5v3.5h5v-10" />
            <path stroke="currentColor" d="M2 13 12 3l10 10" />
        </svg>
    </IconWrapper>
)
